import { useState } from 'react';
import { COMPLIANCE_FOOTER_HTML } from '../../config/readinessQuestions';

/**
 * Persistent compliance footer — shown on every Readiness screen.
 * On mobile the text clamps to a single line with a "More" toggle.
 */
export default function ComplianceFooter() {
  const [expanded, setExpanded] = useState(false);
  return (
    <footer className={'rdz-footer' + (expanded ? ' rdz-footer--expanded' : '')}>
      <img src="/assets/equal-housing-lender.svg" alt="Equal Housing Lender" className="rdz-footer__mark" />
      <p className="rdz-footer__text">
        &copy; 2026 LoanKnow, Inc. NMLS #1192984 (
        <a href={COMPLIANCE_FOOTER_HTML.nmlsUrl} target="_blank" rel="noreferrer">NMLS Consumer Access</a>
        ). Equal Housing Opportunity. LoanKnow is a technology platform, not a lender, and does not
        make credit decisions, originate loans, or issue loan commitments. Your Readiness Score is an
        educational estimate &mdash; not a credit score, loan approval, pre-qualification, or offer of
        credit. Rates shown are samples for illustration only; actual rates, fees, and terms are set by
        participating lenders and subject to their approval. This is not a commitment to lend. Nothing
        is shared with lenders until you choose to submit. We never sell your personal information.
        Owen is an AI assistant and does not provide financial, legal, or tax advice. Licensed
        availability varies by state; currently serving California.
      </p>
      <button
        type="button"
        className="rdz-footer__toggle"
        onClick={() => setExpanded((v) => !v)}
        aria-expanded={expanded}
      >
        {expanded ? 'Less' : 'More'}
      </button>
    </footer>
  );
}
